import React, { useEffect } from "react";
import { getAccessToken } from "../../share/utils";
import { useNavigate } from "react-router-dom";
import Login from "../../pages/Auth/login";

const Protected = (props) => {
  const navigate = useNavigate();
  const token = getAccessToken();

  if (!token) {
    navigate("/login");
    return <Login />;
  }

  return <>{props.children}</>;
};

export default Protected;
